import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketSessionzi1ianvyj32u as WebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClientWebSocketSessionClass;
function DefaultClientWebSocketSession() {
  if (DefaultClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, delegate) {
        this.f61_1 = delegate;
        this.g61_1 = call;
      }
      *p5f(frame, $completion) {
        yield* this.f61_1.p5f(frame, $completion);
        return Unit_instance;
      }
      *c4o($completion) {
        yield* this.f61_1.c4o($completion);
        return Unit_instance;
      }
      l5f(_set____db54di) {
        this.f61_1.l5f(_set____db54di);
      }
      m5f() {
        return this.f61_1.m5f();
      }
      n5f() {
        return this.f61_1.n5f();
      }
      o5f() {
        return this.f61_1.o5f();
      }
      gw() {
        return this.f61_1.gw();
      }
      k5f(negotiatedExtensions) {
        this.f61_1.k5f(negotiatedExtensions);
      }
      j5f() {
        return this.f61_1.j5f();
      }
    }
    initMetadataForClass($, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession(), DefaultWebSocketSession()], [1, 0]);
    DefaultClientWebSocketSessionClass = $;
  }
  return DefaultClientWebSocketSessionClass;
}
var DelegatingClientWebSocketSessionClass;
function DelegatingClientWebSocketSession() {
  if (DelegatingClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, session) {
        this.h61_1 = session;
        this.i61_1 = call;
      }
      *p5f(frame, $completion) {
        yield* this.h61_1.p5f(frame, $completion);
        return Unit_instance;
      }
      *c4o($completion) {
        yield* this.h61_1.c4o($completion);
        return Unit_instance;
      }
      l5f(_set____db54di) {
        this.h61_1.l5f(_set____db54di);
      }
      m5f() {
        return this.h61_1.m5f();
      }
      n5f() {
        return this.h61_1.n5f();
      }
      o5f() {
        return this.h61_1.o5f();
      }
      gw() {
        return this.h61_1.gw();
      }
    }
    initMetadataForClass($, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DelegatingClientWebSocketSessionClass = $;
  }
  return DelegatingClientWebSocketSessionClass;
}
//region block: exports
export {
  DefaultClientWebSocketSession as DefaultClientWebSocketSession1n8ok3lng45wy,
  DelegatingClientWebSocketSession as DelegatingClientWebSocketSessiono1sywc6weckz,
};
//endregion

//# sourceMappingURL=ClientSessions.mjs.map
